import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  Grid
} from '@mui/material';
import { Info, ArrowChevronDown } from '@jda/lui-common-icon-library-mui5';
import { getPaginatedDimensionMembers } from '../../../store/role/policyDimension/dimension';
import { selectDimensionMembers, selectDimensionPolicyData } from '../../../store/role/policyDimension/dimensionSelector';
import { setDimensionPolicyData, setDimensionsMembersData } from '../../../store/role/policyDimension/dimensionActionCreator';
import { SELECTION_MESSAGE, POLICY_DIMENSION_MEMBERS, DIMENSION_LEVEL_LIMIT } from '../../../shared/PolicyDialog/constants';
import { useStyles } from '../../../shared/PolicyDialog/styles';
import CustomListCollector from '../../CustomListCollector/CustomListCollector';

const AccordionListCollector = (props: any) => {
  const { index, id, label, disabled, dimensionId } = props;

  const { classes } = useStyles();
  const dispatch = useDispatch();

  const dimensionMembers: any = useSelector(selectDimensionMembers);
  const dimensionPolicyData = useSelector(selectDimensionPolicyData);

  const [pageNumber, setPageNumber] = useState<any>(0);
  const [searchString, setSearchString] = useState<string>('');
  const [accordionExpanded, setAccordionExpanded] = useState(disabled ? !disabled : false);

  const hierarchyLevels = dimensionPolicyData.hierarchy?.levels;

  useEffect(() => {
    if (!disabled) {
      const searchQuery = searchString.trim().length ? `${id}~${searchString}` : '';
      const reqParams = {
        level: id,
        id: dimensionId,
        filter: searchQuery,
      };
      const offsetIndex = DIMENSION_LEVEL_LIMIT * pageNumber;
      getPaginatedDimensionMembers(dispatch, reqParams, offsetIndex);
    }
  }, [dispatch, searchString, dimensionId, id, disabled, index, pageNumber, dimensionPolicyData.members]);

  const onSubmit = (items: any[]) => {
    const selectedMembersData = { ...dimensionPolicyData.members };
    const membersData = { ...dimensionMembers };
    if (dimensionPolicyData.members !== null && dimensionPolicyData.members[id]?.length !== items.length) {
      hierarchyLevels.forEach((level: any, i: number) => {
        if (i > index) {
          selectedMembersData[level.id] !== undefined && (selectedMembersData[level.id] = []);
          membersData[level.id] !== undefined && (membersData[level.id] = []);
        }
      });
    };
    dispatch(setDimensionPolicyData(POLICY_DIMENSION_MEMBERS, {
      ...dimensionPolicyData.members,
      ...selectedMembersData,
      [id]: items
    }));
    dispatch(setDimensionsMembersData({
      ...dimensionMembers,
      ...membersData
    }));
  };

  const onChangeAccordion = (_evt: object, expanded: boolean) => {
    setAccordionExpanded(expanded);
  };
  return (
    <Accordion
      elevation={0}
      square={false}
      disabled={disabled}
      expanded={accordionExpanded && !disabled}
      onChange={onChangeAccordion}
      className={classes.accordion}
    >
      <AccordionSummary
        id={`level-content-${index}`}
        aria-controls={`level-content-${index}`}
        expandIcon={<ArrowChevronDown color="inherit" />}
      >
        <Typography>{label}</Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.accordionDetails}>
        <Grid className={classes.infoMsg}>
          <Box className={classes.infoIcon}><Info /></Box>
          <Box><Typography>{SELECTION_MESSAGE}</Typography></Box>
        </Grid>
        <CustomListCollector
          onSubmit={onSubmit}
          selectedMembers={dimensionPolicyData?.members ? dimensionPolicyData?.members[id] : []}
          members={dimensionMembers[id] || []}
          onChangePage={(page: any) => setPageNumber(page)}
          setSearchQuery={(searchString: string) => setSearchString(searchString)}
          level={id}
        />
      </AccordionDetails>
    </Accordion>
  )
};

export default AccordionListCollector;